/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type CreateDashboardRequestBody = {
  /**
   * What the dashboard is for, at most 2000 characters
   */
  description?: string | undefined;
  /**
   * Display name, at most 200 characters
   */
  name: string;
};

/** @internal */
export type CreateDashboardRequestBody$Outbound = {
  description?: string | undefined;
  name: string;
};

/** @internal */
export const CreateDashboardRequestBody$outboundSchema: z.ZodMiniType<
  CreateDashboardRequestBody$Outbound,
  CreateDashboardRequestBody
> = z.object({
  description: z.optional(z.string()),
  name: z.string(),
});

export function createDashboardRequestBodyToJSON(
  createDashboardRequestBody: CreateDashboardRequestBody,
): string {
  return JSON.stringify(
    CreateDashboardRequestBody$outboundSchema.parse(createDashboardRequestBody),
  );
}
